import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import {
  actions as reqDiscoverCommunitiesActions,
  paginatedActions as reqPaginatedDiscoverCommunitiesActions,
} from '../../../redux/communities/reqDiscoverCommunities';
import { actions as requestJoinCommunityActions } from '../../../redux/communities/reqJoinCommunity';
import { actions as acceptInvitationActions } from '../../../redux/communities/acceptInvitation';
import {
  makeDiscoverCommunitiesCounterSelector,
  makeDiscoverCommunitiesListSelector,
  sendingDiscoverCommunitiesSelector,
} from '../../../redux/communities/selectors/selectors';

import { DISCOVERY_LIST_TYPES } from '../../../constants';

import styles from '../index.styl';

const mapDispatchToProps = {
  getAllCommunities: reqDiscoverCommunitiesActions.send,
  loadNextCommunities:
    reqPaginatedDiscoverCommunitiesActions.loadNextCommunities,
  reqJoinCommunity: requestJoinCommunityActions.send,
  acceptInvite: acceptInvitationActions.send,
};
const mapStateToProps = state => ({
  organizationCommunitiesList: makeDiscoverCommunitiesListSelector(
    DISCOVERY_LIST_TYPES.ORGANIZATION,
  )(state),
  sendingDiscoverCommunities: sendingDiscoverCommunitiesSelector(state),
  organizationCommunitiesCount: makeDiscoverCommunitiesCounterSelector(
    DISCOVERY_LIST_TYPES.ORGANIZATION,
  )(state),
});

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Communities/OrganizationCommunities/enhance.js